import { render, staticRenderFns } from "./UserContainer.vue?vue&type=template&id=2433fa92&"
import script from "./UserContainer.vue?vue&type=script&lang=js&"
export * from "./UserContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.clcp.cliquedomains.com/web/app/themes/clc-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2433fa92')) {
      api.createRecord('2433fa92', component.options)
    } else {
      api.reload('2433fa92', component.options)
    }
    module.hot.accept("./UserContainer.vue?vue&type=template&id=2433fa92&", function () {
      api.rerender('2433fa92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/vue/Page/UserProfile/UserContainer.vue"
export default component.exports